<template>
  <span v-if="value" :class="`bundle bundle-${color}`">
    {{ $t(`phone-number.number.status.${value}`) }}
  </span>
</template>

<script>
  export default {
    props: {
      value: {
        type: String,
        default: ''
      }
    },

    computed: {
      color: function () {
        /* eslint-disable no-unreachable, vue/script-indent */
        switch (this.value) {
          case 'active': {
            return 'green';
          }
          case 'stand_by': {
            return 'fresh';
          }
          case 'on_deactivation': {
            return 'orange';
          }
          case 'deactivated': {
            return 'error';
          }
          case 'canceled': {
            return 'yellow';
          }
          default: {
            return 'default';
          }
        }
        /* eslint-enable */
      }
    }
  };
</script>
